import {
    addMonths,
    addWeeks,
    addYears,
    endOfMonth,
    endOfWeek,
    endOfYear,
    startOfMonth,
    startOfWeek,
    startOfYear,
    subMonths,
    subWeeks,
    subYears,
} from 'date-fns';

import { COLOR, COLOR_FUNCTION } from '@/globalStyles';

export enum REQUEST_STATUS {
    NEW = 'NEW',
    ACCEPTED = 'ACCEPTED',
    REJECTED = 'REJECTED',
}

export enum DELETION_STATUS {
    DELETION_REQUEST_ACCEPTED = 'DELETION_REQUEST_ACCEPTED',
    DELETION_REQUEST = 'DELETION_REQUEST',
}
export enum REQUEST_RESPONSE_STATUS {
    NEW = 'NEW',
    ACCEPTED = 'ACCEPTED',
    REJECTED = 'REJECTED',
    DELETION_REQUEST_ACCEPTED = 'DELETION_REQUEST_ACCEPTED',
    DELETION_REQUEST = 'DELETION_REQUEST',
}

export const REQUEST_STATUS_TRANSLATIONS = {
    [REQUEST_STATUS.ACCEPTED]: 'absenceStatus_approved_description',
    [REQUEST_STATUS.NEW]: 'absenceStatus_new_description',
    [REQUEST_STATUS.REJECTED]: 'absenceStatus_rejected_description',
    [DELETION_STATUS.DELETION_REQUEST]: 'absenceStatus_deletionRequest_description',
};

export const REQUEST_STATUS_SPECIFIC_DATA = {
    [REQUEST_STATUS.ACCEPTED]: {
        icon: 'check_circle',
        color: COLOR.mountainMeadow,
        translation: REQUEST_STATUS_TRANSLATIONS.ACCEPTED,
    },
    [REQUEST_STATUS.NEW]: {
        icon: 'schedule',
        color: COLOR.darkYellow,
        translation: REQUEST_STATUS_TRANSLATIONS.NEW,
    },
    [REQUEST_STATUS.REJECTED]: {
        icon: 'highlight_off',
        color: COLOR_FUNCTION.primary,
        translation: REQUEST_STATUS_TRANSLATIONS.REJECTED,
    },
    [DELETION_STATUS.DELETION_REQUEST]: {
        icon: 'schedule',
        color: COLOR_FUNCTION.deletionStatus,
        translation: REQUEST_STATUS_TRANSLATIONS.DELETION_REQUEST,
    },
};

export const ALL_STATUSES = [
    REQUEST_STATUS.ACCEPTED,
    REQUEST_STATUS.REJECTED,
    REQUEST_STATUS.NEW,
    DELETION_STATUS.DELETION_REQUEST,
];

export const REQUEST_STATUS_OPTIONS = [
    { value: ALL_STATUSES, label: 'absenceStatus_all_description' },
    ...Object.entries(REQUEST_STATUS_TRANSLATIONS).map(([value, label]) => ({
        value,
        label,
    })),
];

export enum REQUESTS_PERIOD_SELECT {
    UPCOMING_NO_LIMITS = 'UPCOMING_NO_LIMITS',
    UPCOMING_CUR_YEAR = 'UPCOMING_CUR_YEAR',
    UPCOMING_NEXT_YEAR = 'UPCOMING_NEXT_YEAR',
    UPCOMING_CUR_MONTH = 'UPCOMING_CUR_MONTH',
    UPCOMING_NEXT_MONTH = 'UPCOMING_NEXT_MONTH',
    UPCOMING_CUR_WEEK = 'UPCOMING_CUR_WEEK',
    UPCOMING_NEXT_WEEK = 'UPCOMING_NEXT_WEEK',
    UPCOMING_CUSTOM = 'UPCOMING_CUSTOM',
    ARCHIVE_NO_LIMITS = 'ARCHIVE_NO_LIMITS',
    ARCHIVE_CUR_YEAR = 'ARCHIVE_CUR_YEAR',
    ARCHIVE_PREV_YEAR = 'ARCHIVE_PREV_YEAR',
    ARCHIVE_CUR_MONTH = 'ARCHIVE_CUR_MONTH',
    ARCHIVE_PREV_MONTH = 'ARCHIVE_PREV_MONTH',
    ARCHIVE_CUR_WEEK = 'ARCHIVE_CUR_WEEK',
    ARCHIVE_PREV_WEEK = 'ARCHIVE_PREV_WEEK',
    ARCHIVE_CUSTOM = 'ARCHIVE_CUSTOM',
    TO_ACCEPT_NO_LIMITS = 'TO_ACCEPT_NO_LIMITS',
    TO_ACCEPT_CUR_YEAR = 'TO_ACCEPT_CUR_YEAR',
    TO_ACCEPT_NEXT_YEAR = 'TO_ACCEPT_NEXT_YEAR',
    TO_ACCEPT_PREV_YEAR = 'TO_ACCEPT_PREV_YEAR',
    TO_ACCEPT_CUR_MONTH = 'TO_ACCEPT_CUR_MONTH',
    TO_ACCEPT_NEXT_MONTH = 'TO_ACCEPT_NEXT_MONTH',
    TO_ACCEPT_PREV_MONTH = 'TO_ACCEPT_PREV_MONTH',
    TO_ACCEPT_CUR_WEEK = 'TO_ACCEPT_CUR_WEEK',
    TO_ACCEPT_NEXT_WEEK = 'TO_ACCEPT_NEXT_WEEK',
    TO_ACCEPT_PREV_WEEK = 'TO_ACCEPT_PREV_WEEK',
    TO_ACCEPT_CUSTOM = 'TO_ACCEPT_CUSTOM',
}

enum REQUESTS_PERIOD_SELECT_TRANSLATIONS {
    UPCOMING_NO_LIMITS = 'employeesAbsencesRaport_all_title',
    UPCOMING_CUR_YEAR = 'dashboard_chartFilter_currentYear_title',
    UPCOMING_NEXT_YEAR = 'dashboard_chartFilter_nextYear_title',
    UPCOMING_CUR_MONTH = 'dashboard_chartFilter_currentMonth_title',
    UPCOMING_NEXT_MONTH = 'dashboard_chartFilter_nextMonth_title',
    UPCOMING_CUR_WEEK = 'dashboard_chartFilter_currentWeek_title',
    UPCOMING_NEXT_WEEK = 'dashboard_chartFilter_nextWeek_title',
    UPCOMING_CUSTOM = 'employeesAbsencesRaport_periodType_custom_title',
    ARCHIVE_NO_LIMITS = 'employeesAbsencesRaport_all_title',
    ARCHIVE_CUR_YEAR = 'dashboard_chartFilter_currentYear_title',
    ARCHIVE_PREV_YEAR = 'dashboard_chartFilter_previousYear_title',
    ARCHIVE_CUR_MONTH = 'dashboard_chartFilter_currentMonth_title',
    ARCHIVE_PREV_MONTH = 'dashboard_chartFilter_previousMonth_title',
    ARCHIVE_CUR_WEEK = 'dashboard_chartFilter_currentWeek_title',
    ARCHIVE_PREV_WEEK = 'dashboard_chartFilter_previousWeek_title',
    ARCHIVE_CUSTOM = 'employeesAbsencesRaport_periodType_custom_title',
    TO_ACCEPT_NO_LIMITS = 'employeesAbsencesRaport_all_title',
    TO_ACCEPT_CUR_YEAR = 'dashboard_chartFilter_currentYear_title',
    TO_ACCEPT_NEXT_YEAR = 'dashboard_chartFilter_nextYear_title',
    TO_ACCEPT_PREV_YEAR = 'dashboard_chartFilter_previousYear_title',
    TO_ACCEPT_CUR_MONTH = 'dashboard_chartFilter_currentMonth_title',
    TO_ACCEPT_NEXT_MONTH = 'dashboard_chartFilter_nextMonth_title',
    TO_ACCEPT_PREV_MONTH = 'dashboard_chartFilter_previousMonth_title',
    TO_ACCEPT_CUR_WEEK = 'dashboard_chartFilter_currentWeek_title',
    TO_ACCEPT_NEXT_WEEK = 'dashboard_chartFilter_nextWeek_title',
    TO_ACCEPT_PREV_WEEK = 'dashboard_chartFilter_previousWeek_title',
    TO_ACCEPT_CUSTOM = 'employeesAbsencesRaport_periodType_custom_title',
}

enum PREFIX {
    ARCHIVE_ = 'ARCHIVE_',
    UPCOMING_ = 'UPCOMING_',
    TO_ACCEPT_ = 'TO_ACCEPT_',
}

export const UPCOMING_REQUESTS_PERIOD_SELECT_OPTIONS = Object.entries(REQUESTS_PERIOD_SELECT)
    .filter(([value]) => value.startsWith(PREFIX.UPCOMING_))
    .map(([value]) => ({
        label: REQUESTS_PERIOD_SELECT_TRANSLATIONS[value],
        value,
    }));

export const ARCHIVE_REQUESTS_PERIOD_SELECT_OPTIONS = Object.entries(REQUESTS_PERIOD_SELECT)
    .filter(([value]) => value.startsWith(PREFIX.ARCHIVE_))
    .map(([value]) => ({
        label: REQUESTS_PERIOD_SELECT_TRANSLATIONS[value],
        value,
    }));

export const TO_ACCEPT_REQUESTS_PERIOD_SELECT_OPTIONS = Object.entries(REQUESTS_PERIOD_SELECT)
    .filter(([value]) => value.startsWith(PREFIX.TO_ACCEPT_))
    .map(([value]) => ({
        label: REQUESTS_PERIOD_SELECT_TRANSLATIONS[value],
        value,
    }));

export const checkIsCustomPeriod = (period?: REQUESTS_PERIOD_SELECT | string) =>
    Boolean(period) &&
    (period === REQUESTS_PERIOD_SELECT.ARCHIVE_CUSTOM ||
        period === REQUESTS_PERIOD_SELECT.UPCOMING_CUSTOM ||
        period === REQUESTS_PERIOD_SELECT.TO_ACCEPT_CUSTOM ||
        period?.toLowerCase() === 'custom');

const CUR_DATE = new Date();

export const REQUESTS_PERIOD_DATE = {
    [REQUESTS_PERIOD_SELECT.UPCOMING_NO_LIMITS]: {
        startDate: CUR_DATE,
        endDate: endOfYear(addYears(CUR_DATE, 10)),
    },
    [REQUESTS_PERIOD_SELECT.UPCOMING_CUR_YEAR]: {
        startDate: CUR_DATE,
        endDate: endOfYear(CUR_DATE),
    },
    [REQUESTS_PERIOD_SELECT.UPCOMING_NEXT_YEAR]: {
        startDate: startOfYear(addYears(CUR_DATE, 1)),
        endDate: endOfYear(addYears(CUR_DATE, 1)),
    },
    [REQUESTS_PERIOD_SELECT.UPCOMING_CUR_MONTH]: {
        startDate: CUR_DATE,
        endDate: endOfMonth(CUR_DATE),
    },
    [REQUESTS_PERIOD_SELECT.UPCOMING_NEXT_MONTH]: {
        startDate: startOfMonth(addMonths(CUR_DATE, 1)),
        endDate: endOfMonth(addMonths(CUR_DATE, 1)),
    },
    [REQUESTS_PERIOD_SELECT.UPCOMING_CUR_WEEK]: {
        startDate: CUR_DATE,
        endDate: endOfWeek(CUR_DATE),
    },
    [REQUESTS_PERIOD_SELECT.UPCOMING_NEXT_WEEK]: {
        startDate: startOfWeek(addWeeks(CUR_DATE, 1)),
        endDate: endOfWeek(addWeeks(CUR_DATE, 1)),
    },
    [REQUESTS_PERIOD_SELECT.ARCHIVE_NO_LIMITS]: {
        startDate: startOfYear(subYears(CUR_DATE, 10)),
        endDate: CUR_DATE,
    },
    [REQUESTS_PERIOD_SELECT.ARCHIVE_CUR_YEAR]: {
        startDate: startOfYear(CUR_DATE),
        endDate: CUR_DATE,
    },
    [REQUESTS_PERIOD_SELECT.ARCHIVE_PREV_YEAR]: {
        startDate: startOfYear(subYears(CUR_DATE, 1)),
        endDate: endOfYear(subYears(CUR_DATE, 1)),
    },
    [REQUESTS_PERIOD_SELECT.ARCHIVE_CUR_MONTH]: {
        startDate: startOfMonth(CUR_DATE),
        endDate: CUR_DATE,
    },
    [REQUESTS_PERIOD_SELECT.ARCHIVE_PREV_MONTH]: {
        startDate: startOfMonth(subMonths(CUR_DATE, 1)),
        endDate: endOfMonth(subMonths(CUR_DATE, 1)),
    },
    [REQUESTS_PERIOD_SELECT.ARCHIVE_CUR_WEEK]: {
        startDate: startOfWeek(CUR_DATE),
        endDate: CUR_DATE,
    },
    [REQUESTS_PERIOD_SELECT.ARCHIVE_PREV_WEEK]: {
        startDate: startOfWeek(subWeeks(CUR_DATE, 1)),
        endDate: endOfWeek(subWeeks(CUR_DATE, 1)),
    },
    //
    [REQUESTS_PERIOD_SELECT.TO_ACCEPT_NO_LIMITS]: {
        startDate: startOfYear(subYears(CUR_DATE, 10)),
        endDate: endOfYear(addYears(CUR_DATE, 10)),
    },
    [REQUESTS_PERIOD_SELECT.TO_ACCEPT_CUR_YEAR]: {
        startDate: startOfYear(CUR_DATE),
        endDate: endOfYear(CUR_DATE),
    },
    [REQUESTS_PERIOD_SELECT.TO_ACCEPT_NEXT_YEAR]: {
        startDate: startOfYear(addYears(CUR_DATE, 1)),
        endDate: endOfYear(addYears(CUR_DATE, 1)),
    },
    [REQUESTS_PERIOD_SELECT.TO_ACCEPT_PREV_YEAR]: {
        startDate: startOfYear(subYears(CUR_DATE, 1)),
        endDate: endOfYear(subYears(CUR_DATE, 1)),
    },
    [REQUESTS_PERIOD_SELECT.TO_ACCEPT_CUR_MONTH]: {
        startDate: startOfMonth(CUR_DATE),
        endDate: endOfMonth(CUR_DATE),
    },
    [REQUESTS_PERIOD_SELECT.TO_ACCEPT_NEXT_MONTH]: {
        startDate: startOfMonth(addMonths(CUR_DATE, 1)),
        endDate: endOfMonth(addMonths(CUR_DATE, 1)),
    },
    [REQUESTS_PERIOD_SELECT.TO_ACCEPT_PREV_MONTH]: {
        startDate: startOfMonth(subMonths(CUR_DATE, 1)),
        endDate: endOfMonth(subMonths(CUR_DATE, 1)),
    },
    [REQUESTS_PERIOD_SELECT.TO_ACCEPT_CUR_WEEK]: {
        startDate: startOfWeek(CUR_DATE),
        endDate: endOfWeek(CUR_DATE),
    },
    [REQUESTS_PERIOD_SELECT.TO_ACCEPT_NEXT_WEEK]: {
        startDate: startOfWeek(addWeeks(CUR_DATE, 1)),
        endDate: endOfWeek(addWeeks(CUR_DATE, 1)),
    },
    [REQUESTS_PERIOD_SELECT.TO_ACCEPT_PREV_WEEK]: {
        startDate: startOfWeek(subWeeks(CUR_DATE, 1)),
        endDate: endOfWeek(subWeeks(CUR_DATE, 1)),
    },
};
